import React from 'react';
import { useParams } from 'react-router-dom';

const PRODUCTS = {
  electronics: [
    {
      id: 1,
      name: 'iPhone 16 Pro',
      price: '4999',
      image: 'https://images.unsplash.com/photo-1695048133142-1a20484d2569?w=500'
    },
    {
      id: 2,
      name: 'Samsung S25 Ultra',
      price: '4599',
      image: 'https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?w=500'
    }
  ],

  'mens-fashion': [
    {
      id: 3,
      name: 'تيشيرت رجالي',
      price: '149',
      image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=500'
    },
    {
      id: 4,
      name: 'قميص كلاسيك',
      price: '199',
      image: 'https://images.unsplash.com/photo-1603252109303-2751441dd157?w=500'
    }
  ],

  'womens-fashion': [
    {
      id: 5,
      name: 'فستان حريمي',
      price: '299',
      image: 'https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=500'
    },
    {
      id: 6,
      name: 'بلوزة أنيقة',
      price: '179',
      image: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=500'
    }
  ],

  'kids-fashion': [
    {
      id: 7,
      name: 'طقم أطفال',
      price: '129',
      image: 'https://images.unsplash.com/photo-1519238359922-989348752efb?w=500'
    }
  ],

  'home-furniture': [
    {
      id: 8,
      name: 'كنبة مودرن',
      price: '1499',
      image: 'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=500'
    }
  ],

  'home-appliances': [
    {
      id: 9,
      name: 'غسالة أوتوماتيك',
      price: '2199',
      image: 'https://images.unsplash.com/photo-1626806787461-102c1bfaaea1?w=500'
    }
  ],

  'beauty-perfumes': [
    {
      id: 10,
      name: 'عطر فاخر',
      price: '399',
      image: 'https://images.unsplash.com/photo-1541643600914-78b084683601?w=500'
    }
  ],

  'skin-care': [
    {
      id: 11,
      name: 'كريم ترطيب',
      price: '89',
      image: 'https://images.unsplash.com/photo-1571781926291-c477ebfd024b?w=500'
    }
  ],

  'baby-products': [
    {
      id: 12,
      name: 'حفاضات أطفال',
      price: '69',
      image: 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=500'
    }
  ],

  toys: [
    {
      id: 13,
      name: 'سيارة ألعاب',
      price: '99',
      image: 'https://images.unsplash.com/photo-1558060370-d644479cb6f7?w=500'
    }
  ],

  books: [
    {
      id: 14,
      name: 'كتاب تطوير الذات',
      price: '59',
      image: 'https://images.unsplash.com/photo-1512820790803-83ca734da794?w=500'
    }
  ],

  sports: [
    {
      id: 15,
      name: 'كرة قدم',
      price: '119',
      image: 'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=500'
    }
  ],

  grocery: [
    {
      id: 16,
      name: 'سلة بقالة',
      price: '79',
      image: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=500'
    }
  ]
};

const CATEGORY_NAMES = {
  electronics: 'الإلكترونيات',
  'mens-fashion': 'أزياء رجالي',
  'womens-fashion': 'أزياء حريمي',
  'kids-fashion': 'أزياء الأطفال',
  'home-furniture': 'المنزل والأثاث',
  'home-appliances': 'الأجهزة المنزلية',
  'beauty-perfumes': 'الجمال والعطور',
  'skin-care': 'العناية بالبشرة',
  'baby-products': 'منتجات الأطفال',
  toys: 'الألعاب',
  books: 'الكتب',
  sports: 'مستلزمات رياضية',
  grocery: 'البقالة'
};

const CategoryPage = () => {
  const { slug } = useParams();

  const products = PRODUCTS[slug] || [];

  return (
    <div className="bg-[#F6F5F2] min-h-screen" dir="rtl">
      {/* Hero */}
      <div className="bg-white border-b">
        <div className="container mx-auto px-4 py-12 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1B1B1F] mb-4">
            {CATEGORY_NAMES[slug] || 'الفئة'}
          </h1>

          <p className="text-gray-600">
            اكتشف أفضل المنتجات والعروض داخل هذه الفئة
          </p>
        </div>
      </div>

      {/* Products */}
      <div className="container mx-auto px-4 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.length > 0 ? (
            products.map((product) => (
              <div
                key={product.id}
                className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-64 object-cover"
                />

                <div className="p-5">
                  <h3 className="font-bold text-lg text-[#1B1B1F]">
                    {product.name}
                  </h3>

                  <p className="text-[#F2B705] text-xl font-bold mt-2">
                    {product.price} ر.س
                  </p>

                  <button
                    className="w-full mt-4 bg-[#F2B705] hover:bg-[#1B1B1F]
                    hover:text-white text-[#1B1B1F] py-3 rounded-xl
                    font-bold transition-colors"
                  >
                    أضف للسلة
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="col-span-full text-center py-20">
              <h2 className="text-2xl font-bold text-gray-500">
                لا توجد منتجات في هذه الفئة حالياً
              </h2>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoryPage;
